// src/pages/CMS/Admin/Login/ProtectRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getToken } from "../../../../utils/cmsAuth";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ roles }) {
  const location = useLocation();
  const { ready, me, authError, reload } = useAuth();


  if (!ready) return null;

  const token = getToken();
  const isLoginPage = location.pathname === "/admin/login";

  if (!me && authError && !isLoginPage) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-white text-slate-800 dark:bg-[#0b111c] dark:text-slate-100">
        <p role="alert">{authError}</p>
        <button
          type="button"
          onClick={() => reload(false)}
          className="rounded-lg border border-slate-300 px-4 py-2 dark:border-slate-600"
        >
          다시 시도
        </button>
      </div>
    );
  }

  if (!token || !me) {
    // 이미 로그인 화면이면 그대로 두기
    if (isLoginPage) return <Outlet />;
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  if (roles && roles.length > 0 && !roles.includes(me.role)) {
    return <Navigate to="/cms" replace />;
  }

  return <Outlet />;
}
